import "./new.scss";
import Sidebar from "../components/sidebar/Sidebar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
  collection,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Navbar1 from "../../main/Navbar1";
import Spinner from "../../Spinner";
import EmptyList from "../../blog/components/common/EmptyList";

let id = '';
let theme1 = 'Amélioration des variétés et des semences';
let theme2 = 'Amélioration et restauration des sols';
let theme3 = 'Protection des plantes';
let theme4 = 'Pisciculture';
let theme5 = 'Agroindustrie';

const themes = [
  {
    label: theme1,
    value: theme1,
  },
  {
    label: theme2,
    value: theme2,
  },
  {
    label: theme3,
    value: theme3,
  },
  {
    label: theme4,
    value: theme4,
  },
  {
    label: theme5,
    value: theme5,
  }
];

const Examinator = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [per, setPerc] = useState(null);
  const [user, setUser] = useState({
    id: '',
    theme : '',
    city : '',
    country: '',
    displayName: '',
    email: '',
    phone: '',
    whatsapp: '',
    createdBy: '',
    createdAt: '',
    });

    const [creator, setCreator] = useState({
        id: '',
        displayName: ''
        });
  const [update, setPageUpdate] = useState(false);

  let [firstRender, setFirstRender] = useState({
    firstRender: true,
  });

  const [currentTheme, setTheme] = useState({
    value: '',
  });

  const [mainTheme, setMainTheme] = useState({
    value: '',
  });

  const changePage = () => {
    setPageUpdate(current => !current)
    console.log(update)
  };

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [fileSummary, setFileSummary] = useState([]);
  const [fileEvaluation, setFileEvaluation] = useState([]);

  const handleThemeChange = (e) => {
    currentTheme.value  = e.target.value;
    // setTheme({...currentTheme, [currentTheme]:e.target.value});
    setUser({ ...user, 'theme': e.target.value });
  };
  
  const getFileSummary = async (id) => {
    try {
        const unsub = onSnapshot(
            collection(db, `users/${id}/summary`),
            (snapShot) => {
              let list = [];
              snapShot.docs.forEach((doc) => {
                list.push({ id: doc.id, ...doc.data() });
              });
              setFileSummary(list);
            },
            (error) => {
              console.log(error);
            }
          );
      
          return () => {
            unsub();
        };
    } catch (error) {
        console.log(error)
    }
  };

  const getFileEvaluation = async (id) => {
    try {
        const unsub = onSnapshot(
            collection(db, `users/${id}/evaluation`),
            (snapShot) => {
              let list = [];
              snapShot.docs.forEach((doc) => {
                list.push({ id: doc.id, ...doc.data()});
              });
              setFileEvaluation(list);
            },
            (error) => {
              console.log(error);
            }
          );
      
          return () => {
            unsub();
        };
    } catch (error) {
        console.log(error)
    }
  };

  useEffect(() => {
    // getting user details
    if(firstRender){
        getUserDetails().then(data => {
            if(data != null){
                setUser(data);
                setMainTheme(data.theme);
                getCreatorDetails(data.createdBy).then(res => {
                    setCreator(res);
                });
                getFileSummary(data.id);
                getFileEvaluation(data.id);
                setFirstRender(false);
            }
        });
    }
  }, []);

  const handleReturn = async (id) => {
    navigate(-1);
  }

  const getUserDetails = async () => {
    try {
        const userRef = doc(db, "users", id);
        const userSnap = await getDoc(userRef);
        
        if(userSnap.exists()){
        return userSnap.data();
        }
        else{
        return null;
        }
    } catch (error) {
        if(error.toString().includes("offline")){
            window.alert('Pas de connexion internet')
        }
        else{
            window.alert(error)
        }
    }
};

const getCreatorDetails = async (uid) => {
    try {
        const userRef = doc(db, "users", uid);
        const userSnap = await getDoc(userRef);
        
        if(userSnap.exists()){
        return userSnap.data();
        }
        else{
        return null;
        }
    } catch (error) {
        if(error.toString().includes("offline")){
            window.alert('Pas de connexion internet')
        }
        else{
            window.alert(error)
        }
    }
};

const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setUser({ ...user, [name]: value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    // setIsLoading(true);
    try {
      
      try {
          await updateDoc(doc(db, "users", id), {
          ...user,
          });
          await updateDoc(doc(db, "exam", id), {
            ...user,
            });
          window.alert("Modifié");
          changePage();
      } catch (error) {
          setIsLoading(false);
          console.log(error);
          if(error.toString().includes("offline")){
              window.alert('Pas de connexion internet')
          }
          else{
              window.alert(error)
          }
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const handleDelete = async (e) => {
    if(window.confirm(t('confirm_delete'))){
        setIsLoading(true);
        try {
        await deleteDoc(doc(db, "exam", id));
        await deleteDoc(doc(db, "users", id));
        window.alert("Supprimé");
        navigate(-1);
        } catch (error) {
            setIsLoading(false);
            if(error.toString().includes("offline")){
                window.alert('Pas de connexion internet')
            }
            else{
                window.alert(error)
            }
        }
    }
  };

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar1 />
        <input type="button" className="btn btn-primary m-3" value={t('return')} onClick={handleReturn}/>
        {
          user ?(
            <div>
              {!update && (
                <div>
                  <div className="card m-3 p-2">
                    <h1>{user.displayName}</h1>
                    <h3 className="text-success">{user.theme}</h3>
                    <p>Email: {user.email}</p>
                    <p>{t('phone')}: {user.phone}</p>
                    <p>{t('city')}: {user.city}</p>
                    <p>{t('country')}: {user.country}</p>
                    <p>{t('created_by')}: <span className="text-primary">{creator.displayName}</span></p>
                    <br /><br />
                    
                    <h2>{t('evaluation_report')}</h2>
                    <p>{t('summary_sheet')} : <span>
                      {fileSummary.length > 0 ? 
                        <a href={fileSummary.at(0).url}>lien de téléchargement</a>
                        :
                        ''
                      }
                      </span></p>
                    <p>{t('evaluation_sheet')} : <span>
                      {fileEvaluation.length > 0 ? 
                        <a href={fileEvaluation.at(0).url}>lien de téléchargement</a>
                        :
                        ''
                      }
                      </span></p>
                  </div>
                  <input type="button" className="btn btn-outline-primary m-3" value="modifier" onClick={()=>{changePage()}}/>
                  <input type="button" className="btn btn-danger m-3" value="supprimer" onClick={()=>{handleDelete()}}/>
                </div>
              )}
              {update && (
                <div>
                  <div className="bottom">
                    <div className="right">
                      <form onSubmit={handleUpdate}>
                        <div className="formInput">
                            <label>{t('full_name')}</label>
                            <input
                              type="text"
                              name="displayName"
                              placeholder={t('full_name')}
                              value={user.displayName}
                              onChange={handleInput}
                            />
                        </div>
                        <div className="formInput">
                            <label>{t('city')}</label>
                            <input
                              type="text"
                              name="city"
                              placeholder={t('city')}
                              value={user.city}
                              onChange={handleInput}
                            />
                        </div>
                        <div className="formInput">
                            <label>{t('country')}</label>
                            <input
                              type="text"
                              name="country"
                              placeholder={t('country')}
                              value={user.country}
                              onChange={handleInput}
                            />
                        </div>
                        <div className="formInput">
                            <label>{t('phone')}</label>
                            <input
                              type="text"
                              name="phone"
                              placeholder={t('phone')}
                              value={user.phone}
                              onChange={handleInput}
                            />
                        </div>
                        <div className="col-md-12">
                            <h3>{t('update_theme')}</h3>
                            <select value={currentTheme.value} onChange={handleThemeChange}>
                                {themes.map((option) => (
                                    <option value={option.value}>{option.label}</option>
                                ))}
                            </select>
                            <p className="mt-4">{t('choosen_theme')} : <span className="fw-bolder">{user.theme}</span></p>
                        </div>
                        {/**
                         * value ={step.patentNumber} onChange={handleInput}
                         * 
                         */}
                        <div className="d-flex">
                          <input type="button" className="btn btn-primary m-3" value="annuler" onClick={()=>{
                            changePage();
                          }}/>
                          <button className="btn btn-outline-primary m-3" disabled={per !== null && per < 100} type="submit">
                            {t('save')}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )  : (
            <EmptyList />
          )
        }
      </div>
    </div>
  );
};

export default Examinator;
